<template lang="html">
  <div class="i-process">
    <div class="i-process-bg" :style="{width: `${width}%`}"></div>
  </div>
</template>

<script>
export default {
  name: 'i-process',
  props: {
    width: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
.i-process {
  background: #f5f5f5;
  height: 6px;
  border-radius: 10px;
  .i-process-bg {
    height: 100%;
    background: #2e6be6;
    border-radius: 10px;
    width: 10%;
  }
}
</style>
